var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2765_397)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2765_397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2765_397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0234 18.1873C49.0232 18.8101 48.9002 19.4267 48.6615 20.0019C48.4229 20.5771 48.0733 21.0997 47.6326 21.5397C47.1919 21.9798 46.6689 22.3287 46.0933 22.5665C45.5177 22.8043 44.901 22.9264 44.2782 22.9258L5.7197 22.9258C4.81468 22.9261 3.92848 22.6674 3.16572 22.1803C2.40296 21.6932 1.79548 20.9981 1.41501 20.177C0.636102 18.4898 0.912273 18.9361 2.10602 17.5356L12.4443 5.38476C14.1423 3.38437 13.604 3.14336 15.5995 4.83584C16.5569 5.65044 17.1519 6.81172 17.2539 8.06467C17.3558 9.31762 16.9563 10.5598 16.1431 11.5185L12.4443 15.8642L44.2782 15.8642C46.8991 15.8646 49.0234 15.5684 49.0234 18.1873Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.976593 31.758C0.976849 31.1352 1.09981 30.5186 1.33846 29.9434C1.5771 29.3682 1.92674 28.8456 2.36741 28.4056C2.80808 27.9655 3.33115 27.6166 3.90671 27.3788C4.48227 27.141 5.09905 27.0189 5.72181 27.0195L44.2803 27.0195C45.1853 27.0193 46.0715 27.2779 46.8343 27.765C47.597 28.2521 48.2045 28.9472 48.585 29.7684C49.3639 31.4555 49.0877 31.0092 47.894 32.4097L37.5557 44.5605C35.8577 46.5609 36.396 46.802 34.4005 45.1095C33.4431 44.2949 32.8481 43.1336 32.7461 41.8806C32.6442 40.6277 33.0437 39.3855 33.8569 38.4269L37.5557 34.0812H5.72181C3.10091 34.0807 0.976593 34.377 0.976593 31.758Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2765_397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionWhite);
export default __webpack_public_path__ + "static/media/transaction_white.2ccd217f784a8b3f249f6087ddb65321.svg";
export { ForwardRef as ReactComponent };